import classNames from 'classnames';
import React from 'react';
import './Page.scss';
import PageContent from './PageContent';
import PageSidebar from './PageSidebar';

interface PageProps extends React.HTMLProps<HTMLDivElement> {
  children: React.ReactNode | React.ReactNode[];
}

const Page = ({ children, className, ...rest }: PageProps) => {
  return (
    <div className="zb-container zb-container-fluid">
      <div className={classNames('mss-page', className)} {...rest}>
        {children}
      </div>
    </div>
  );
};

Page.Content = PageContent;
Page.Sidebar = PageSidebar;

export default Page;
